export default __webpack_public_path__ + "static/media/event_popup_point.512c691c.png";